export const menu = {
  name: '',
  description: '',
  enabled: true,
};
